import { render, staticRenderFns } from "./UserSelectField.vue?vue&type=template&id=3d15b40c&"
import script from "./UserSelectField.vue?vue&type=script&lang=js&"
export * from "./UserSelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports